var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2-renderer-exclude",class:[
        'bg-stone-100 lg:hidden duration-300 ease-in-out flex flex-col justify-center transition-all flex-shrink max-h-max absolute bottom-0 w-full',
        _vm.isOpen ? 'p-4 border-t border-stone-300' : 'p-0',
    ],style:(`height: ${_vm.isOpen ? _vm.elementHeight : '0px'}; min-height: ${_vm.isOpen ? _vm.elementHeight : '0px'}; overflow:${_vm.overflow};`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }